var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 821.751,
    height: 886.619,
    viewBox: "726.5 -104.735 821.751 886.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1463.23 55.352 1222.397-82.2c-52.613-30.048-117.43-30.048-170.042 0L811.52 55.35C758.911 85.4 726.5 140.932 726.5 201.026v275.1c0 11.017 1.1 21.875 3.203 32.455 9.367 47.138 38.852 88.68 81.818 113.22l240.834 137.549c52.612 30.047 117.43 30.047 170.042 0L1463.23 621.8c41.053-23.45 69.806-62.414 80.457-106.958a166.387 166.387 0 0 0 4.564-38.719V201.025c0-60.095-32.411-115.626-85.02-145.673",
    fill: "#feae34",
    fillRule: "evenodd",
    "data-name": "Path 35582"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.5750bf244737b70366505258b02fcd2b.svg";
export { ForwardRef as ReactComponent };